import { create, update, find, get } from "@/api/canalDeVendas"
import { ParametrosDeAtualizacaoCanaldeVendas } from "@/models";
import { CanalDeVendasServiceAdapter } from "@/usecases";
import { injectable } from "inversify-props";

@injectable()
export class CanaldeVendasService implements CanalDeVendasServiceAdapter {
	get = async (id: string) => await get(id)
	find = async (params?: any) => await find(params)
	create = async (parametros: ParametrosDeAtualizacaoCanaldeVendas)=> { 
		const formData = new FormData()
		if (!parametros.file) {
			throw new Error("Para criar um canal de vendas é necessário uma imagem.");
		}
		formData.append('file', parametros.file)
		formData.append('nome', parametros.nome)
		return await create(formData) 
	}
	update = async (parametros: ParametrosDeAtualizacaoCanaldeVendas) => {
		const formData = new FormData()
		if (!parametros.id) {
			throw new Error("Para atualizar um canal de vendas é necessário um ID.");
		}
		if (parametros.file) {
			formData.append('file', parametros.file)
		}
		formData.append('nome', parametros.nome)
		return await update(parametros.id, formData)
	}
}